export const ACTIVITY_SOURCE = {
  WILDERNESS: 'wilderness',
  JACADA: 'jacada',
};

// Related-option relation types, verbatim from the Wilderness pricing file's
// Related Options sheet ("Relation Type" column).
export const RELATION_TYPE = {
  MANDATORY: 'Mandatory',
  OPTIONAL: 'Optional',
};

// Relation an activity's catalog edges (relatedParents: [{ optionKey, relationType }])
// declare towards one parent option. A parent listed under both types counts as
// Mandatory; an unlisted parent yields undefined, meaning the catalog knows of no
// relation and the caller decides.
export const relationTypeForParent = (relatedParents, parentOptionKey) => {
  if (!parentOptionKey) return undefined;
  const edges = (relatedParents ?? []).filter(edge => edge.optionKey === parentOptionKey);
  if (!edges.length) return undefined;
  return edges.some(edge => edge.relationType === RELATION_TYPE.MANDATORY) ? RELATION_TYPE.MANDATORY : RELATION_TYPE.OPTIONAL;
};
